import { InstrumentTypeResponse } from "../../codegen-api";
import {
  IOptionMarketData,
  IPerpetualMarketData,
} from "./MarketsTable";

export enum MarketFiltersEnum {
  ALL_MARKETS = "all_markets",
  WATCHLIST = "watchlist",
  CRYPTO = "crypto",
  STOCKS = "stocks",
  COMMODITIES = "commodities",
  FX = "fx",
  INDICES = "indices",
  PRE_IPO = "pre_ipo",
}

export type ISectionData = {
  name: string;
  instrumentType: InstrumentTypeResponse;
  isPrelaunch: boolean;
} & (
  | {
      instrumentType: typeof InstrumentTypeResponse.Option;
      data: IOptionMarketData[];
    }
  | {
      instrumentType: typeof InstrumentTypeResponse.Perpetual;
      data: IPerpetualMarketData[];
    }
  | {
      instrumentType: typeof InstrumentTypeResponse.Spot;
      data: IPerpetualMarketData[];
    }
);
